import {
  TbLayoutSidebarLeftCollapseFilled,
  TbLayoutSidebarLeftCollapse,
  TbLayoutBottombarCollapseFilled,
  TbLayoutBottombarCollapse,
  TbLayoutSidebarRightCollapseFilled,
  TbLayoutSidebarRightCollapse,
} from "react-icons/tb";
import { StyledHeaderCollapseMenu } from "./index.styled";
import { useTypedDispatch, useTypedSelector } from "@lib/redux";
import {
  updateFooter,
  updateRightPanel,
  updateSidebar,
} from "@lib/redux/slices/screen";
import { StyledHeaderButton } from "@lib/components/StyledComponents/layout";

export default function AdminHeaderCollapseMenu() {
  const dispatch = useTypedDispatch();
  const {
    sidebar,
    footer,
    rightPanel,
    header,
    window: windowState,
  } = useTypedSelector((state) => state.screen);
  const isMobile = windowState?.width < windowState?.breakpointHide;

  const handleCollapseSidebar = () => {
    if (windowState?.width < windowState?.breakpointHide) {
      dispatch(updateSidebar({ hidden: !sidebar.hidden }));
    } else {
      dispatch(updateSidebar({ collapsed: !sidebar.collapsed }));
    }
  };

  const handleCollapseFooter = () => {
    dispatch(updateFooter({ collapsed: !footer.collapsed }));
  };

  const handleCollapseRightPanel = () => {
    dispatch(updateRightPanel({ collapsed: !rightPanel.collapsed }));
  };

  const renderSidebarIcon = () => {
    if (windowState?.width < windowState?.breakpointHide) {
      return sidebar.hidden ? (
        <TbLayoutSidebarLeftCollapse />
      ) : (
        <TbLayoutSidebarLeftCollapseFilled />
      );
    } else {
      return sidebar.collapsed ? (
        <TbLayoutSidebarLeftCollapse />
      ) : (
        <TbLayoutSidebarLeftCollapseFilled />
      );
    }
  };

  return (
    <StyledHeaderCollapseMenu height={header.height - 5}>
      {!isMobile && !sidebar.dontOpen && (
        <StyledHeaderButton onClick={handleCollapseSidebar}>
          {renderSidebarIcon()}
        </StyledHeaderButton>
      )}

      {footer.enabled && (
        <StyledHeaderButton onClick={handleCollapseFooter}>
          {footer.collapsed ? (
            <TbLayoutBottombarCollapse />
          ) : (
            <TbLayoutBottombarCollapseFilled />
          )}
        </StyledHeaderButton>
      )}

      {rightPanel.enabled && (
        <StyledHeaderButton onClick={handleCollapseRightPanel}>
          {rightPanel.collapsed ? (
            <TbLayoutSidebarRightCollapse />
          ) : (
            <TbLayoutSidebarRightCollapseFilled />
          )}
        </StyledHeaderButton>
      )}
    </StyledHeaderCollapseMenu>
  );
}
